import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider, Icon, List, message, Modal } from "antd";
// import { capitalizeFirstLetter, checkUndefine } from "../../../../../../helpers/functions";
import "./SyncModal.less";
import Input from "containers/backend/common/component/Input";
import { LoadingComponent } from "containers/backend/common/component/Index";
import { checkUndefine } from "helpers/functions";

const SyncModal = ({ ...props }) => {
  const { t } = useTranslation();
  const { parseExcelClearData, visible, setVisible, handleOkSyncModal, title } =
    props;
  const [rateCodes, setRateCodes] = useState([]);
  const [promotionCodeInput, setPromotionCodeInput] = useState("");
  const [rateCodesError, setRateCodesError] = useState({});

  const handleCancel = () => {
    setRateCodes([]);
    clearData();
  };

  const clearData = () => {
    setVisible(false);
    setPromotionCodeInput("");
    setRateCodesError({});
    parseExcelClearData && parseExcelClearData();
  };

  const onChangeValue = (e) => {
    setPromotionCodeInput(e.target.value);
  };

  const onRemoveRateCodes = (item) => {
    if (item) {
      const oldRateCodes = rateCodes;
      const newRateCodes = oldRateCodes.filter((eleItem) => {
        return eleItem !== item;
      });
      setRateCodes([...newRateCodes]);
    }
  };

  const addPromotionCodeToList = () => {
    const oldRateCodes = [...rateCodes];
    const inputPromotionCode = promotionCodeInput.trim();

    if(!inputPromotionCode){
      return
    }

    if (oldRateCodes.length >= 20) {
      return message.warning({
        content: t("item.hotel.rates.rateCodeMaximum"),
      });
    }
    
    const existedRateCodes = oldRateCodes.filter((item) => {
      return (
        item &&
        inputPromotionCode &&
        item.toLowerCase() === inputPromotionCode.toLowerCase()
      );
    });
    if (existedRateCodes && existedRateCodes.length <= 0) {
      oldRateCodes.unshift(inputPromotionCode);
      setPromotionCodeInput("");
      setRateCodes([...oldRateCodes]);
    } else {
      message.warning({
        content: t(`item.hotel.rates.rateCodeDuplicate`),
      });
    }
  };

  return (
    <Fragment>
      <Modal
        title={
          <>
            {t(`item.hotel.rates.selectRateCode`)} - {title}
          </>
        }
        width={800}
        visible={visible}
        onOk={() => rateCodes.length > 0 && handleOkSyncModal(rateCodes)}
        onCancel={handleCancel}
        maskClosable={false}
        okButtonProps={{ disabled: !rateCodes.length }}
      >
        <LoadingComponent spinning={false}>
          <div className="import-promotion-code-modal-container">
            <div className="promotion-code-container">
              <Input
                type={`text`}
                className={`form-control`}
                name={`email`}
                value={checkUndefine(promotionCodeInput)}
                autoComplete="off"
                onChange={onChangeValue}
                onPressEnter={addPromotionCodeToList}
                disable={checkUndefine(promotionCodeInput)}
              />
              <Button
                disabled={
                  !checkUndefine(promotionCodeInput.trim())
                }
                type="primary ml-2 same-height-with-textbox"
                onClick={addPromotionCodeToList}
              >
                {t(`action.add`)}
              </Button>
            </div>
            <Divider orientation={"left"} />
            <div
              className={
                rateCodesError && rateCodesError.errors
                  ? "promotion-code-list-container"
                  : "promotion-code-list-container-without-error"
              }
            >
              <List
                size="small"
                bordered
                dataSource={rateCodes}
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Icon
                        type="close-circle"
                        className="fs18 cursorPointer"
                        onClick={() => onRemoveRateCodes(item)}
                      />,
                    ]}
                  >
                    {item}
                  </List.Item>
                )}
              />
            </div>
          </div>
        </LoadingComponent>
      </Modal>
    </Fragment>
  );
};

export default SyncModal;
